module.exports = __webpack_public_path__ + "static/media/dublin-bus.f633b149.png";